import styled from 'styled-components';

import { Link } from '../../../components';
import { ThemeProp } from '../../../theme/Themes';

export const RememberForgotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`;

export const BottomContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
`;

export const ForgotYourPasswordLink = styled(Link)`
  text-align: right;
`;

export const CodeInstruction = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
  margin-bottom: 1.5rem;
`;

export const CodeInstructionEmail = styled(CodeInstruction)`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
`;
